import { render, staticRenderFns } from "./Donut.vue?vue&type=template&id=10e48848&"
import script from "./Donut.vue?vue&type=script&lang=js&"
export * from "./Donut.vue?vue&type=script&lang=js&"
import style0 from "./Donut.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports